var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1351 18.1666H24.3018C26.2635 18.1666 27.8538 19.757 27.8538 21.7187V35.2812C27.8538 37.243 26.2635 38.8333 24.3018 38.8333H19.1351C17.1733 38.8333 15.583 37.243 15.583 35.2812V21.7187C15.583 19.757 17.1733 18.1666 19.1351 18.1666ZM20.7497 24.625V32.375C20.7497 32.91 21.1834 33.3437 21.7184 33.3437C22.2534 33.3437 22.6872 32.91 22.6872 32.375V24.625C22.6872 24.0899 22.2534 23.6562 21.7184 23.6562C21.1834 23.6562 20.7497 24.0899 20.7497 24.625ZM32.6976 18.1666H37.8643C39.826 18.1666 41.4163 19.757 41.4163 21.7187V35.2812C41.4163 37.243 39.826 38.8333 37.8643 38.8333H32.6976C30.7358 38.8333 29.1455 37.243 29.1455 35.2812V21.7187C29.1455 19.757 30.7358 18.1666 32.6976 18.1666ZM35.6038 25.5937V27.5312H33.9893C33.4543 27.5312 33.0205 27.965 33.0205 28.5V32.375C33.0205 32.91 33.4543 33.3437 33.9893 33.3437H36.5726C37.1076 33.3437 37.5413 32.91 37.5413 32.375C37.5413 31.84 37.1076 31.4062 36.5726 31.4062H34.958V29.4687H36.5726C37.1076 29.4687 37.5413 29.035 37.5413 28.5V24.625C37.5413 24.0899 37.1076 23.6562 36.5726 23.6562H33.9893C33.4543 23.6562 33.0205 24.0899 33.0205 24.625C33.0205 25.16 33.4543 25.5937 33.9893 25.5937H35.6038Z",
    fill: "#083857"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#083857",
    fillOpacity: 0.05
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevIcon1);
export default __webpack_public_path__ + "static/media/dev-icon-1.9bf76a89290963de3836a80c893f05c7.svg";
export { ForwardRef as ReactComponent };